document.addEventListener('DOMContentLoaded', function () {
  const Exchanges = {
    NSE: 'nse',
    BSE: 'bse',
  };

  const nseTag = document.getElementById('nse-tag');
  const bseTag = document.getElementById('bse-tag');

  function setExchange(exchange) {
    document.cookie = `indices-listing-exchange=${exchange}; path=/;`;
    setActiveClass(exchange);
    window.location.reload();
  }

  function setActiveClass(exchange) {
    if (exchange.toLowerCase() === Exchanges.NSE && nseTag) {
      nseTag.classList.add('active');
      bseTag.classList.remove('active');
    } else if (exchange.toLowerCase() === Exchanges.BSE && bseTag) {
      bseTag.classList.add('active');
      nseTag.classList.remove('active');
    }
  }

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  let exchange = getCookie('indices-listing-exchange') || Exchanges.NSE;
  setActiveClass(exchange);

  if (nseTag) {
    nseTag.addEventListener('click', function () {
      setExchange(Exchanges.NSE);
    });
  }
  if (bseTag) {
    bseTag.addEventListener('click', function () {
      setExchange(Exchanges.BSE);
    });
  }

  const currentTimeElement = document.getElementById('current-time');

  if (currentTimeElement) {
    function updateTime() {
      const now = new Date();

      const formattedDate = now.toLocaleDateString('en-GB').replace(/\//g, '-');

      const options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      };
      const formattedTime = now.toLocaleTimeString('en-GB', options);

      currentTimeElement.textContent = `${formattedDate} ${formattedTime}`;
    }
    updateTime();

    setInterval(updateTime, 60000);
  }
});
